import React from 'react';

import Box from '@mui/material/Box';


import { Profils } from 'constants.js';
import { TypeCodes } from 'constants.js';


import DepotGestionAutocomplete from 'components/Shared/DepotGestionAutocomplete';
import { estDepotPlateforme, sansDepotMagasin } from 'utils/depotHelper';


const MagasinStep = ({ reclamation, onNextStepValid, onChange, onChangeClient }) => {
    
    const [required, setRequired] = React.useState(true);
    const [disabled, setDisabled] = React.useState(false);


    const [depots, setDepots] = React.useState(null);

    const [codeDepot, setCodeDepot] = React.useState(reclamation.magasin ? reclamation.magasin.codeDepot : '');

    // Initialisation du composant
    React.useEffect(() => {

        // Le choix n'est requis que si l'utilisateur est MAG
        let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));

        //console.log(utilisateur);

        var depots = [];
        var depotImpose = null;

        if (utilisateur.codePoste !== Profils.Magasinier)
        {
            setRequired(false);
        }

        let depotsValides = [];
        if (utilisateur.depots)
        {
            depotsValides = utilisateur.depots.filter(x => !estDepotPlateforme(x.code));
        }

        if (sansDepotMagasin(utilisateur)) {
            if (depotsValides.length === 0) {
                // Cas 1 - Dépot et dépots vide => Choix parmis tout les dépots
                //console.log('Cas 1');
            }
            else {
                if (depotsValides.length > 1) {
                    // Cas 2 - Dépot vide et dépots non => Choix parmis les dépots
                    //console.log('Cas 2');

                    depots = [...depotsValides];
                }
                else {
                    // Cas 3 - Dépot vide et dépots unique => Pas de choix, le seul 'des' dépots
                    //console.log('Cas 3 dépot:', depotsValides[0]);

                    depotImpose = depotsValides[0];
                    depots = [depotsValides[0]];
                }
            }
        }
        else {
            // Cas 4 et 5 - Dépot non vide et peut importe dépots  => Pas de choix, Dépot
            //console.log('Cas 4 ou 5 dépot:', utilisateur.depot);

            depotImpose = utilisateur.depot;
            depots = [utilisateur.depot]
        }

        setDepots(depots);

        // L'unique code dépot est préchargé
        if (depotImpose)
        {
            //console.log('depotImpose:', depotImpose);

            setDisabled(true);
            onNextStepValid(true);
            setCodeDepot(depotImpose.code);

            let event = {
                target: {
                    name: "magasin",
                    value: {
                        codeDepot: depotImpose.code,
                        nom: depotImpose.nom,
                        verrou: true
                    }
                }
            };

            let errors = [];

            onChange(event, errors);
        }
        else
        {
            //console.log('depot NON imposé');

            onNextStepValid(false);
            if (utilisateur.codePoste !== Profils.Magasinier) {

                let event = {
                    target: {
                        name: "magasin",
                        value: {
                            codeDepot: '',
                            nom: '',
                            verrou: false
                        }
                    }
                };

                let errors = [];

                if (required && !codeDepot) {
                    errors.push({ key: "magasin", errorMsg: "Pour quel magasin souhaitez-vous faire le dossier après-vente ?" });
                }

                onChange(event, errors);
            }
        }

    }, []);


    // A la sélection du codeDepot, on l'enregistre et on autorise le passage à l'étape suivante.
    const handleChange = (codeDepot, depot) => {

        onNextStepValid(!!codeDepot || !required);

        let event = {
            target: {
                name: "magasin",
                value: {
                    ...depot,
                    verrou: required
                }
            }
        }; // Requis et verrouillé si MAG

        let errors = [];

        if (required && !codeDepot) {
            errors.push({ key: "magasin", errorMsg: "Pour quel magasin souhaitez-vous faire le dossier après-vente ?" });
        }

        onChange(event, errors);

        if (depot && depot.clientCession && reclamation.type.code === TypeCodes.Cession) {
            onChangeClient({ ...depot.clientCession, chargerContact: true, verrou: true }, []);
        }

        setCodeDepot(codeDepot);
    }

    let helper = reclamation.type.code === TypeCodes.Cession ? "Le choix du magasin impliquera le client cession" : '';


    return (
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <Box p={2} sx={{ width: 550, backgroundColor: 'white' }}>

                {depots !== null && (

                    <DepotGestionAutocomplete
                        value={codeDepot}
                        onChange={(e, codeDepot, depot) => { handleChange(codeDepot, depot); }}
                        label={"Pour quel magasin souhaitez-vous faire le dossier après-vente ?"}
                        magasinsSeulement={true}
                        plateformesSeulement={false}
                        autoFocus
                        modeTri={0}
                        required={required}
                        disabled={disabled}
                        depotsGestion={depots}
                        disableClearable={disabled}
                        helperText={helper}
                    />
                
                )}

            </Box>
        </Box>  
    );

}

export default MagasinStep;

